import { clientTranscript } from "../config/axios";
import { clientAWS } from "../config/awsConfig";
import { ParamsData } from "../components/upload_audio/paramsData";

export const getTranscriptsByID = async () => {
  const response = await clientTranscript.get(`/transcriptions/1500`);
  return response.data;
};

export const uploadAudio = async (
  userData,
  audioFile,
  customName,
  dispatch
) => {
  const s3 = clientAWS();

  s3.upload(ParamsData({ userData, audioFile, customName }))
    .on("httpUploadProgress", (progress) => {
      const percent = Math.round((progress.loaded / progress.total) * 100);
      dispatch({ type: "UPDATE_PROGRESS", payload: percent });
    })
    .send((err, data) => {
      if (err) {
        dispatch({
          type: "UPLOAD_FAILURE",
          payload: "Error al subir el archivo.",
        });
        console.error("Error al subir el archivo:", err);
      } else {
        dispatch({ type: "UPLOAD_SUCCESS" });
        dispatch({ type: "SET_CUSTOM_NAME", payload: "" });
        console.log("Archivo subido correctamente:", data);
      }
    });
};

export const getTranscriptionFinal = async (audioUrl) => {
  const s3 = clientAWS();

  const params = {
    Bucket: "mentu-class-audios",
    Key: audioUrl,
  };

  try {
    const data = await s3.getObject(params).promise();
    return JSON.parse(data.Body.toString("utf-8"));
  } catch (err) {
    console.error("Error al obtener el objeto de S3:", err);
    throw err;
  }
};

export const uploadTranscriptionToS3 = async (audioUrl, transcriptionData) => {
  const s3 = clientAWS();

  const params = {
    Bucket: "mentu-class-audios",
    Key: audioUrl,
    Body: JSON.stringify(transcriptionData),
    ContentType: "application/json",
  };

  try {
    const data = await s3.putObject(params).promise();
    console.log("Archivo subido exitosamente a S3:", data);
    return data;
  } catch (err) {
    console.error("Error al subir el objeto a S3:", err);
    throw err;
  }
};